export default __webpack_public_path__ + "static/media/dullingblow3.cc29093f.png";